/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL2NsaWVudGVzL2VkaXRhci9lZGl0YXItY2xpZW50ZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Tb3VyY2UvZVNvZnRDZXJlYWwuQVBJL2VTb2Z0Q2VyZWFsLlVJL3NyYy9hcHAvY2xpZW50ZXMvZWRpdGFyL2VkaXRhci1jbGllbnRlLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/$$_gendir/app/clientes/editar/editar-cliente.component.scss.shim.ngstyle.ts